import React, { useState } from "react";
import { diffWords } from "diff";
import { Accordion, Icon } from "semantic-ui-react";
import "semantic-ui-css/semantic.min.css";
import "./DiffModal.css";

const DiffModal = ({ show, onCancel, changes, onRevertSection, title = "Compare History Logs" }) => {
  const [activeIndex, setActiveIndex] = useState(null);

  if (!show || !changes?.length) return null;

  const handleAccordionClick = (index) => {
    setActiveIndex(activeIndex === index ? null : index);
  };

  const renderDiff = (oldValue, newValue, type) => {
    const diffArray = diffWords(oldValue ?? "", newValue ?? "");
    return diffArray.map((part, index) => {
      if (type === "old") {
        if (part.removed) return <span key={index} className="diff-modal-deleted">{part.value}</span>;
        if (!part.added) return <span key={index}>{part.value}</span>;
      } else if (type === "new") {
        if (part.added) return <span key={index} className="diff-modal-added">{part.value}</span>;
        if (!part.removed) return <span key={index}>{part.value}</span>;
      }
      return null;
    });
  };

  return (
 <div
			className="modal show d-block"
			tabIndex="-1"
			role="dialog"
			style={{ backgroundColor: "rgba(0,0,0,0.5)", zIndex: 9999 }}
		>
			<div
				className="modal-dialog modal-xl"
				role="document"
			
			>
				<div className="modal-content">
					<button
						type="button"
						className="close linear-gradient"
						aria-label="Close"
						onClick={onCancel}
					>
						X
					</button>

         <div className="modal-header">
              <h5 style={{fontSize:"1.6rem", fontFamily:"Lato,Helvetica Neue,Arial,Helvetica,sans-serif"}} className="modal-title" >{title}</h5>
					</div>
            <div  className='modal-body parsedatap ' style={{paddingTop:"10px"}}>

         <Accordion fluid styled>
  {changes.map((change, index) => (
    <React.Fragment key={index}>
      <Accordion.Title active={activeIndex === index} onClick={() => handleAccordionClick(index)}>
        <Icon name="dropdown" />
        {change.section_name}
      </Accordion.Title>
      <Accordion.Content active={activeIndex === index}>
        <div className="ui grid">
          <div className="eight wide column">
            <h6>Old Version</h6>
            <div className="diff-modal-diff-box">
              {renderDiff(change.old_value, change.new_value, "old")}
            </div>
          </div>
          <div className="eight wide column">
            <h6>New Version</h6>
            <div className="diff-modal-diff-box">
              {renderDiff(change.old_value, change.new_value, "new")}
            </div>
          </div>
        </div>
      </Accordion.Content>
    </React.Fragment>
  ))}
</Accordion>
</div>
          	<div className="modal-footer">
						<button
							type="button"
							onClick={onCancel}
							className="yr-cancelbtn linear-gradient-cancel btn-sm yr-btn-small"
						>
							<span>Cancel</span>
						</button>
						{/* <button
							type="button"
							onClick={onRevertSection}
							className="btn linear-gradient yr-submitbtn btn-sm"
						>
							<span>Revert All</span>
						</button> */}
					</div>

          </div>

        </div>
      </div>

  );
};

export default DiffModal;
